import { Component } from "react";
import { reportException } from "../../logging";
import { decideErrorCode, checkCacheAvailable } from "../../services/utils";
import BlockCookieUi from "../BlockCookieUi";

class ErrorBoundary extends Component {
  state = {
    isCacheError: false
  };
  componentDidCatch(error, info) {
    const reportObj = {
      error,
      errorInfo: info,
      errorCode: decideErrorCode(error, "ERROR-BOUNDARY")
    };
    if (!checkCacheAvailable()) {
      this.setState({
        isCacheError: true
      });
      return;
    }
    reportException(reportObj);
  }

  render() {
    const { isCacheError } = this.state;
    return isCacheError ? <BlockCookieUi /> : this.props.children;
  }
}

export default ErrorBoundary;
